































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiCommande from '@/api/commande'
import { toSubArray } from '@/utils/groupBy'
import ReadInformation from '@/components/administration/commande/read/ReadInformation.vue'
import ReadAdresse from '@/components/administration/commande/read/ReadAdresse.vue'
import ReadItems from '@/components/administration/commande/read/ReadItems.vue'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { directPayloadQuery } from '@/utils/api'
import {DashboardAdmin} from '@/router/pages'
import cloneDeep from 'clone-deep'
import { AloMedia, getDefaultAloMedia } from '@/models/alo/AloMedia'


@Component({
  name: 'ModifyCommande', 
  props: {
    commandeId:Number
  },
  components: { ReadInformation,ReadAdresse,ReadItems}
})

export default class ModifyCommande extends Vue {
  commandeId!: number
  private showError = false    
  private rightDrawer = false
  private loading = false

  get commande(){
    return this.$store.myGetters.commandeDic[this.commandeId] || getDefaultAloCommande()
  }



  loadCommande() {    
    this.loading = true    
    this.$store.myActions.ADM_COMMANDE_DETAIL_REQUEST(this.commandeId).finally(() => {      
      this.loading = false      
    })    
  }

  created(){
    this.loadCommande()
  }  

  get arianeItems() {
    const arianeItems =  [
        DashboardAdmin,
        {
          text: 'Commandes',
          disabled: false,  
          to: {name:'AdminCommande'},        
          exact:true
        }
      ]
    if(this.commande) {
        arianeItems.push({
          text: this.commande.libelle,
          disabled: true,             
          to: {name:''},                         
          exact:true
        })
    }
    return arianeItems;
  } 

}
